
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { Region } from '@/model/region';
import { cloneDeep } from 'lodash';

export default Vue.extend({
  name: 'selectionRegion',
  data: () => ({
    regionSelectionnee: null as Region
  }),
  computed: {
    ...mapGetters({
      _listeRegions: 'user/listeRegionUser',
      _regionSelectionnee: 'user/regionSelectionnee',
      infoTiers: 'tiers/infosTiers'
    }),
    listeRegions (): Region[] {
      let tabRegion = cloneDeep((this._listeRegions || []) as Region[]).map(region => {
        region.libelle = region.libelle.toLowerCase().replace(/(\W|^)\w/g, c => c.toUpperCase());
        return region;
      }).filter((r: Region) => r.libelle !== 'Activites Centrales');

      if (this.hasRole(this.Roles.USER_ADHERENT) && this.infoTiers) {
        tabRegion = [this.infoTiers.region];
      }
      return tabRegion;
    },
    isListeMultiple (): boolean {
      return this.listeRegions.length > 1;
    }
  },
  watch: {
    regionSelectionnee () {
      this.setRegionSelectionnee(this.regionSelectionnee || null);
    }
  },

  created () {
    this.init();
  },
  methods: {
    ...mapActions({
      setRegionSelectionnee: 'user/setRegionSelectionnee'
    }),
    init () {
      if (this._regionSelectionnee) {
        this.regionSelectionnee = this.listeRegions.find(r => r.codeRegion === this._regionSelectionnee.codeRegion);
      } else {
        this.regionSelectionnee = this.listeRegions[0];
      }
    },
    regionIsEqual (a: Region, b: Region) {
      return a?.codeRegion === b?.codeRegion;
    }
  }
});
